/**
 * @group Data
 *
 * @summary
 * <blockquote>Supported EHR provider types for patient integrations.</blockquote>
 *
 * @example
 * ```typescript
 * import { EHR_PROVIDERS } from '@shared/constants';
 *
 * const provider = EHR_PROVIDERS.OPENEMR;
 * // 'openemr'
 * ```
 */
export const EHR_PROVIDERS = {
  OPENEMR: 'openemr',
  EPIC: 'epic',
  CERNER: 'cerner',
  ALLSCRIPTS: 'allscripts',
} as const;
